<template>
	<VideoTransparency
		:src="activeVideo.url"
		:size="{ height: activeVideo.height, width: activeVideo.width }"
		v-bind="$attrs"
		v-on="$listeners"
		@ended="completeVideo"
	/>
</template>

<script>
import VideoTransparency from "@/components/base/VideoTransparency";

export default {
	name: 'VideoSequence',
	components: {
		VideoTransparency,
	},
	model: {
		prop: 'state',
		event: 'transition',
	},
	props: {
		state: {
			required: true,
			type: String,
		},
		videoMap: {
			required: true,
			type: Object,
		},
		transitions: {
			required: false,
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		activeVideo() {
			const video = this.videoMap[this.state];
			return { ...video, ...this.$store.getters["global/assets/get"](video.id) };
		},
	},
	methods: {
		completeVideo() {
			const nextState = this.transitions[this.state];
			if (nextState) {
				this.$emit('transition', nextState, this.state);
			}

			this.$emit('videoEnd', this.state);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/VideoSequence.vue